// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertySearchResultActions_propertyV5_graphql = require("../../__generated__/PropertySearchResultActions_propertyV5_graphql.bs.js");

let convertFragment = PropertySearchResultActions_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertySearchResultActions_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertySearchResultActions_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertySearchResultActions_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertySearchResultActions_propertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertySearchResultActions(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertySearchResultActions_propertyV5_graphql.node, convertFragment, props.property);
  let id = property.id;
  let sharingEnabled = UserSession.useHasPlanFeature("SHARE_WITH_CLIENT");
  let match = property.status;
  let isWithdrawn = match !== undefined ? match.__typename === "WithdrawnProperty" : false;
  return JsxRuntime.jsxs("div", {
    children: [
      sharingEnabled ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          href: `/properties/` + id + `/share`,
          disabled: isWithdrawn,
          size: "small",
          className: "flex-1 justify-center",
          icon: "share",
          children: "Share with client"
        }) : null,
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        href: `/properties/` + id,
        size: "small",
        className: "flex-1 justify-center",
        icon: "view-details",
        children: "View details"
      })
    ],
    className: "flex gap-2"
  });
}

let make = PropertySearchResultActions;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
